import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { outgoingBreadcrumbItems } from 'data/returning';
import OutgoingFilterReturning from './filter/OutgoingFilterReturning';
import OutgoingReturningTable from './OutgoingReturningTable';
import ButtonRefresh from 'components/base/ButtonRefresh';

const OutgoingReturnig = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  // const handleRefetch = () => {
  //   queryClient.refetchQueries('GET_RETURN_OUT_MAIN');
  // };

  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [optionSenderId, setOptionSenderId] = useState(null);
  const [optionStatusId, setOptionStatusId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div>
      <PageBreadcrumb items={outgoingBreadcrumbItems} />
      <div>
        <div className="mb-5 d-flex gap-2 align-items-center">
          <h2>{t('outgoing')}</h2>
          <ButtonRefresh
            onRefresh={() => queryClient.refetchQueries('GET_RETURN_OUT_MAIN')}
          />
        </div>

        <OutgoingFilterReturning
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          setOptionSenderId={setOptionSenderId}
          setOptionStatusId={setOptionStatusId}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          setCurrentPage={setCurrentPage}
        />
        <OutgoingReturningTable
          dateFrom={dateFrom}
          dateTo={dateTo}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default OutgoingReturnig;
